import { useState, useEffect } from 'react';
import brandLogo from '../../assets/images/IE_logo.png';
import tel from '../../assets/images/phone.svg';
import wa from '../../assets/images/whatsapp.svg';
import Navbar from '../Navbar/Navbar';
import HelpHeader from './HelpHeader';
import whats from '../../assets/images/whats.png';
import Link from '../../components/Link/Link';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const Header = (props) => {
  // const { children } = props;
  const { auth: isAuth, profileTrackerCode } = useSelector(
    (state) => state.user
  );

  const [toggle, setToggle] = useState(true);
  useEffect(() => {
    if (window.innerWidth <= 768) {
      setToggle(false);
    }
  }, []);

  const location = useLocation();

  // Check if the path starts with "/posp/training/agreement"
  const isAgreementPage =
    location.pathname.startsWith('/posp/training/agreement') ||
    location.pathname.startsWith('/posp/training/submited-agreement');

  return (
    !isAgreementPage && (
      <>
        {/* <HelpHeader /> */}
        <div className="sticky top-0 left-0 z-[1000]">
          <header className="relative">
            <div className="relative mb-8 flex flex-wrap md:flex-nowrap items-center justify-around w-full py-4 px-4 text-lg text-gray-700 bg-white">
              <Link to={`${isAuth ? '/posp/dashboard' : '/'}`}>
                <img
                  className="inline-block max-w-[200px] mr-8  "
                  src={brandLogo}
                  alt={'Insure Efficient'}
                />
              </Link>

              <svg
                onClick={() => setToggle((p) => !p)}
                xmlns="http://www.w3.org/2000/svg"
                id="menu-button"
                className="h-6 w-6 cursor-pointer md:hidden block"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <Navbar toggle={toggle} />

              {isAuth === true && profileTrackerCode === 6 ? null : (
                <div className="flex gap-16 mt-4 md:m-0">
                  {!isAuth ? (
                    <Link to={'/posp/login'}>
                      <button className=" px-4 py-1 xl:px-1 rounded-xl font-bold  text-blue-900 text-s outline outline-offset-2 outline-1 ">
                        Login{' '}
                      </button>
                    </Link>
                  ) : (
                    ''
                  )}

                  <a href="https://wa.me/917400063232">
                    <img
                      className="inline-block max-w-[200px] xl:w-36 xl:mr-16  scale-125"
                      src={whats}
                      width={'170px'}
                      alt={'Insure Efficient'}
                    />
                  </a>
                </div>
              )}
              {/* <div className="items-self-end w-[autp] max-w-[500px] grid grid-flow-col gap-x-10 justify-items-end justify-self-end">
              <div className="relative inline-block ">
                <div className="h-full inline-grid grid-rows-1 grid-cols-[1fr_3fr] items-center">
                  <img src={tel} className="inline justify-self-center" />
                  <p className="flex flex-col font-medium text-sm">
                    <span>Call Us (Toll Free):</span>
                    <a
                      className="relative inline-block font-bold text-base"
                      href="tel:18002678949"
                    >
                      1800 267 8949
                    </a>
                  </p>
                </div>
              </div>
              <div className="relative inline-block">
                <div className="h-full inline-grid grid-rows-1 grid-cols-[1fr_3fr] items-center">
                  <img src={wa} className="inline justify-self-center" />
                  <p className="flex flex-col font-medium text-sm">
                    <span>Whatsapp Us:</span>
                    <a
                      className="relative inline-block font-bold text-base"
                      href="tel:+917400063232"
                    >
                      +91 74000 63232
                    </a>
                  </p>
                </div>
              </div>
            </div> */}
            </div>
            {/* <div className="relative -bottom-1/2"> */}
            {/* </div> */}
          </header>
          {/* <div className="relative bottom-9"><Navbar /></div> */}
        </div>
      </>
    )
  );
};

export default Header;
